<template>
  <div>
    <div class="wrap">
      <div class="modal-dim on">
        <!--'on 추가'-->
        <div class="modal-wrap">
          <div class="modal-inner center">
            <div class="modal">
              <div class="modal-head">
                <h1></h1>
              </div>
              <div class="modal-con">
                <div class="modal-txt">
                  <p>로그아웃 하시겠습니까?</p>
                </div>
              </div>
              <div class="modal-btn">
                <div class="btn-wrap">
                  <button class="btn gray" @click.prevent="fnClose">취소</button>
                  <button class="btn" @click.prevent="fnLogout">확인</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-logout-index',
  inheritAttrs: false,
  customOptions: {}
};
</script>

<script setup>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { defineEmits, reactive } from 'vue';
import Util from '@/common/utils/Util';
const { commit, dispatch } = useStore();
const { replace } = useRouter();

const emit = defineEmits(['close']);

const fnClose = () => {
  emit('close');
};

const state = reactive({
  params: {
    device: {},
    user: {}
  }
});

const fnLogout = async () => {
  if (!Util.isEmpty(localStorage.getItem('deviceInfo'))) {
    state.params.device = JSON.parse(localStorage.getItem('deviceInfo'));
  }
  const userData = JSON.parse(localStorage.getItem('userData'));
  state.params.user = userData;
  console.log(state.params);
  await dispatch('user/logout', state.params);
  await replace('/login');
};
</script>
